module.exports = __webpack_public_path__ + "img/candle-quartz-3.64de3b07.jpg";